import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxId,
    taxAgencyName,
    taxCalculationPeriod,
    taxAlternatePayerId,
    taxAlternatePayerName,
    timeSign,
  },
} = checkout;

const initialValues = {
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxAlternatePayerId.name]: "",
  [taxAlternatePayerName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
